<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'metatableviews_new'" (ttClick)="goToFunc('metatableview')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListMetaTableViews"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="metatableviews_new" tt-click="vm.goToFunc('metatableview')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListMetaTableViews" badge="" ltype="" design-var="s12t0"></tt-list>
</tt-page>-->
